import * as Yup from 'yup';

const validationSchema = Yup.object({
    sports_name: Yup.string()
        .trim()
        .max(50, 'Must be 50 characters or less')
        .required('Sports type is required'),
    holiday_price: Yup.number('Holiday price must be a number')
        .positive('Holiday price must be a positive value')
        .required('Holiday price is required')
        .min(1, 'Your holiday price must be greater than or equal to 1!'),
    weekday_price: Yup.number('Weekday price must be a number')
        .positive('Weekday price must be a positive value')
        .required('Weekday price is required')
        .min(1, 'Your weekday price must be greater than or equal to 1!'),
    weekend_price: Yup.number('Weekend price must be a number')
        .positive('Weekend price must be a positive value')
        .required('Weekend price is required')
        .min(1, 'Your weekend price must be greater than or equal to 1!')
});

export default validationSchema;